/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The styles use handwriting and script fonts already on your device, so no external fonts are loaded and the tool stays fast and private. The exact look may vary slightly by device.`)
};

const es_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los estilos utilizan fuentes de escritura manual y script ya en tu dispositivo, por lo que no se cargan fuentes externas y la herramienta se mantiene rápida y privada. La apariencia exacta puede variar ligeramente según el dispositivo.`)
};

const de_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Stile verwenden Hand- und Skriptschriftarten, die bereits auf Ihrem Gerät vorhanden sind, sodass keine externen Schriftarten geladen werden und das Tool schnell und privat bleibt. Das genaue Erscheinungsbild kann je nach Gerät leicht variieren.`)
};

const nl_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De stijlen gebruiken handschrift- en scriptlettertypen die al op uw apparaat aanwezig zijn, dus geen externe lettertypen worden geladen en het gereedschap blijft snel en privé. Het exacte uiterlijk kan per apparaat enigszins verschillen.`)
};

const fr_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les styles utilisent des polices manuscrites et de script déjà sur votre appareil, donc aucune police externe n'est chargée et l'outil reste rapide et privé. L'apparence exacte peut varier légèrement selon l'appareil.`)
};

const it_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli stili utilizzano caratteri calligrafici e di script già presenti sul tuo dispositivo, quindi nessun carattere esterno viene caricato e lo strumento rimane veloce e privato. L'aspetto esatto può variare leggermente a seconda del dispositivo.`)
};

const pt_br2_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os estilos usam fontes cursivas e script já no seu dispositivo, então nenhuma fonte externa é carregada e a ferramenta permanece rápida e privada. A aparência exata pode variar um pouco dependendo do dispositivo.`)
};

const pt_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os estilos usam fontes de caligrafia e script já no seu dispositivo, portanto nenhumas fontes externas são carregadas e a ferramenta permanece rápida e privada. A aparência exacta pode variar ligeiramente por dispositivo.`)
};

const ja_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルはデバイスに既にある手書きおよびスクリプトフォントを使用するため、外部フォントは読み込まれず、ツールは高速かつプライベートのままです。正確な外観はデバイスによって若干異なる場合があります。`)
};

const zh_sig_type_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些风格使用您设备上已有的笔迹和脚本字体，因此不会加载外部字体，工具保持快速和私密。确切的外观可能因设备而略有不同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq1_a", locale)
	if (locale === "en") return en_sig_type_faq1_a(inputs)
	if (locale === "es") return es_sig_type_faq1_a(inputs)
	if (locale === "de") return de_sig_type_faq1_a(inputs)
	if (locale === "nl") return nl_sig_type_faq1_a(inputs)
	if (locale === "fr") return fr_sig_type_faq1_a(inputs)
	if (locale === "it") return it_sig_type_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq1_a(inputs)
	if (locale === "pt") return pt_sig_type_faq1_a(inputs)
	if (locale === "ja") return ja_sig_type_faq1_a(inputs)
	return zh_sig_type_faq1_a(inputs)
};